import panzoom from 'panzoom'
class Panzoom {
  constructor (element) {
    this.el = element

    this.imageProperties = {
      width: this.el.offsetWidth / 2,
      height: this.el.offsetHeight / 2,
    }
    this.instance = panzoom(element, {
      maxScale: 1.2,
      transformOrigin: {
        x: 0.5,
        y: 0.5
      },
      showRectangle: true
    })
  }

  zoomIn () {
    this.instance.smoothZoom(this.el.offsetWidth / 2, this.el.offsetHeight / 2, 1.5)
  }

  zoomOut () {
    this.instance.smoothZoom(this.el.offsetWidth / 2, this.el.offsetHeight / 2, (1 / 1.5))
  }
}

export default Panzoom
